import ministryService from "../../../../services";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { hasError } from "@/utils/utils";
export default {
  namespaced: true,
  state: () => {
    return {
      working: false,
      loading: false,
      incentives: [],
      incentive: {},
    };
  },
  getters: {
    working(state) {
      return state.working;
    },
    loading(state) {
      return state.loading;
    },
    incentives(state) {
      return state.incentives;
    },
    incentive(state) {
      return state.incentive;
    },
  },
  mutations: {
    setWorking(state, payload) {
      state.working = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setData(state, payload) {
      state.incentives = payload;
    },
    setShowData(state, payload) {
      state.incentive = payload;
    },
  },
  actions: {
    async getIncentives({ commit }) {
      commit("setLoading", true);
      try {
        const data = await ministryService.getIncentives();
        commit("setData", data.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async getIncentive({ commit }, id) {
      commit("setLoading", true);
      try {
        const data = await ministryService.getIncentive(id);
        commit("setShowData", data.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async editIncentive({ commit }, payload) {
      commit("setWorking", true);
      try {
        const res = await ministryService.updateIncentive(payload);

        if (hasError(res.status)) {
          throw res.status;
        }

        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم التعديل بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });

        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setWorking", false);
      }
    },
    async addIncentive({ commit }, payload) {
      commit("setWorking", true);
      try {
        const res = await ministryService.addIncentive(payload);

        if (hasError(res.status)) {
          throw res.status;
        }

        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت الإضافة بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setWorking", false);
      }
    },
    async deleteIncentive({ commit }, id) {
      commit("setWorking", true);
      try {
        const res = await ministryService.deleteIncentive(id);

        if (hasError(res.status)) {
          throw res.status;
        }

        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم الحذف بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setWorking", false);
      }
    },
  },
};
